import { useMemo, useState } from "react";
import { ModalShell } from "./ModalShell";

export function CreatePollModal({
  onClose,
  onCreate,
}: {
  onClose: () => void;
  onCreate: (question: string, options: string[]) => void;
}) {
  const [question, setQuestion] = useState("");
  const [opts, setOpts] = useState("Yes\nNo");
  const optionList = useMemo(
    () =>
      opts
        .split("\n")
        .map((t) => t.trim())
        .filter(Boolean),
    [opts],
  );
  const canCreate = !!question.trim() && optionList.length >= 2;

  return (
    <ModalShell
      title="New poll"
      ariaLabel="Create poll"
      onClose={onClose}
      size="sm"
      className="add-contact-card"
      footer={
        <div className="actions-row">
          <button type="button" className="btn secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn"
            disabled={!canCreate}
            onClick={() => onCreate(question.trim(), optionList)}
          >
            Create poll
          </button>
        </div>
      }
    >
      <div className="stack">
        <p className="muted text-sm" style={{ margin: 0 }}>
          Polls travel inside the encrypted chat — only group members can see the question and
          who voted.
        </p>
        <div className="field">
          <label htmlFor="pollQ">Question</label>
          <input id="pollQ" value={question} onChange={(e) => setQuestion(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="pollOpts">Options (one per line, at least 2)</label>
          <textarea id="pollOpts" rows={4} value={opts} onChange={(e) => setOpts(e.target.value)} />
        </div>
        {!canCreate && (
          <p className="muted text-sm" role="status" style={{ margin: 0 }}>
            {!question.trim()
              ? "Add a question to create this poll."
              : `Need ${Math.max(0, 2 - optionList.length)} more option${2 - optionList.length === 1 ? "" : "s"}.`}
          </p>
        )}
      </div>
    </ModalShell>
  );
}
